import { FormattedMessage } from "react-intl";
import React, { Component } from 'react';
import {reduxForm} from 'redux-form';
import { Modal } from 'react-bootstrap';
import bt from '../../../components/commonStyle.css';
import { graphql } from 'react-apollo';

import  messages from "../../../locale/messages";
import s from './ViewVehicleModal.css';
import cx from 'classnames';
import { Table} from 'react-bootstrap';
import CustomPagination from '../../CustomPagination';

import getVehiclesByUser from './getVehiclesUser.graphql';
import { flowRight as compose } from 'lodash';
import {closeViewVehiclesModal} from "../../../actions/siteadmin/modalActions";
import withStyles from "isomorphic-style-loader/withStyles";
import { connect } from "react-redux";
import verified from "../../../../public/Icons/verified.svg";
import notVerified from "../../../../public/Icons/notVerified.svg";
import darkModeverified from "../../../../public/Icons/darkModeVerified.svg";
import darkModenotVerified from "../../../../public/Icons/darkModenotVerified.svg";
import Link from "../../Link/Link";
class ViewVehicleModal extends Component {

    constructor(props){
        super(props)
        this.state = {
            currentpage:1
        }
        this.paginationData = this.paginationData.bind(this);
    }
    paginationData(currentpage) {
        const { vehicles: { refetch } } = this.props;
        let variables = { currentpage };
        this.setState({ currentpage });
        refetch(variables);
      }
        render(){
            const {closeViewVehiclesModal, modalShow, dispatch, vehicles, selectedTheme} = this.props;
            const {currentpage} = this.state;


            return(
                <div>
                    <Modal show={modalShow} onHide= {closeViewVehiclesModal} className={'wooberlyModal viewVehicleModal'} backdrop='static'>
                        <Modal.Header closeButton>
                            <Modal.Title >
                                <div className={s.titleDescription}>
                                     <span><FormattedMessage {...messages.vehiclesInfo}/></span>
                                </div>
                            </Modal.Title>
                        </Modal.Header>  
                        <Modal.Body className={s.logInModalBody}>
                            <div className={s.root}>
                                <div className={cx(s.tableCss,'tableSticky', 'NewResponsiveTable', 'topScrollbarTable',s.tableVehicles)}>
                                    <Table className={cx("table", 'topScrollbarTableContent')} >
                                        <thead>
                                            <tr>
                                                <th><FormattedMessage {...messages.vehicleUser}/></th>
                                                <th><FormattedMessage {...messages.verified}/></th>
                                                <th><FormattedMessage {...messages.action}/></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {vehicles && vehicles.getVehiclesByUser && vehicles.getVehiclesByUser.vehicles && vehicles.getVehiclesByUser.vehicles.map((item, index)=>{
                                                return <tr key={index}><td> {item.vehicleName}</td> 
                                                <td> <span> <img src={(item.vehicleRC === null || item.vehicleRC === undefined)? selectedTheme === "dark"?darkModenotVerified :notVerified:selectedTheme === "dark"?darkModeverified:verified}/></span></td>
                                                <td><Link key={index} to={'/siteadmin/vehicles/'+item.id+'/true'} onClick={closeViewVehiclesModal}><FormattedMessage {...messages.seeDetails}/></Link></td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </Table>
                                
                                </div>
                                {
                                    vehicles && vehicles.getVehiclesByUser && vehicles.getVehiclesByUser.vehicles && vehicles.getVehiclesByUser.vehicles.length > 0
                                    && <div className={cx(bt.space5, bt.spaceTop5)}>
                                      <CustomPagination
                                        total={vehicles.getVehiclesByUser.count}
                                        currentPage={currentpage}
                                        defaultCurrent={1}
                                        defaultPageSize={5}
                                        change={this.paginationData}
                                        paginationLabel={<FormattedMessage {...messages.vehicles}/>}
                                      />
                                    </div>
                                }
                            </div>

                        </Modal.Body>

                    </Modal>
                </div>
            );
        }


}

ViewVehicleModal = reduxForm({
    form: "ViewVehicleModal", // a unique name for this form
    destroyOnUnmount: false
  })(ViewVehicleModal);
const mapState =(state)=> ({
    modalShow: state.adminModalStatus.modalShow,
    selectedTheme: state.currency.theme
});
const mapDispatch = {
    closeViewVehiclesModal,
 };

 export default compose(withStyles(s,bt),(connect(mapState,mapDispatch)),(graphql(getVehiclesByUser, {
    name: 'vehicles',
    options: (props)=> ({
      variables: {
        currentpage: 1,
        id:props.id
      },
      ssr: false,
      fetchPolicy: 'network-only'
    })
})))(ViewVehicleModal);